module.exports = __webpack_public_path__ + "static/mastercard-8526f81273bd894dcd25bc8962ac506d.svg";